<template>
  <div class="productos-otro">

    <div class="crea-tu-formulario">Opcionales</div>
    <div>
      <div class="frame-container">
          <div class="frame-wrapper" v-if="false">
              <div class="frame-div">
                  <div class="pregunta-de-seleccin-selecci-wrapper">
                      <div class="cantidad">
                          <ol class="pregunta-de-seleccin-selecci">
                              <li>Check box, seleccione las opciones deseadas</li>
                          </ol>
                      </div>
                  </div>
              </div>
          </div>
          <template v-if="categories.length">
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(category,i) in categories"
                :key="i"
              >
                <v-expansion-panel-header>
                  {{ category }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="frame-parent1" v-for="(item, i) in fields" :key="i">
                    <div class="ellipse-parent" v-if="item.category === category">
                      <input type="checkbox" v-model="codes" :value="item.code" class="rectangle-div">
                      <div class="opcin-1-wrapper">
                          <div class="aadir-opcin">{{ products[item.code].description }}</div>
                          <div style="display: flex;"><input
                            type="number"
                            style="background-color: white; text-align: end; justify-content: end; width: 45px;"
                            v-model.number="quantities[item.code]"
                          ></div>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
          <div class="frame-parent1" v-else v-for="(item, i) in fields" :key="i">
            <div class="ellipse-parent">
              <input type="checkbox" v-model="codes" :value="item.code" class="rectangle-div">
              <div class="opcin-1-wrapper">
                  <div class="aadir-opcin">{{ products[item.code].description }}</div>
                  <div style="display: flex;"><input
                    type="number"
                    style="background-color: white; text-align: end; justify-content: end; width: 45px;"
                    v-model.number="quantities[item.code]"
                  ></div>
              </div>
            </div>
          </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'OptionalsAddProduct',
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    fields: {
      type: Array,
      default: () => ([])
    },
    products: {
      type: Object,
      default: () => ({})
    },
    currency: {
      type: String,
      default: 'CRC'
    }
    // exchangeRate: {
    //   type: Number,
    //   default: 1
    // },
    // priceList: {
    //   type: String,
    //   default: 'general'
    // }
    // Aquí es donde se declararían las propiedades de tu componente
  },
  data () {
    return {
      lazyValue: this.value,
      codes: [],
      quantities: {}
    }
  },
  computed: {
    categories () {
      return this.fields.reduce((acc, curr) => {
        if (acc.includes(curr.category)) return acc
        acc.push(curr.category)
        return acc
      }, [])
    },
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', this.lazyValue)
      }
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
    },
    fields: {
      deep: true,
      handler (val) {
        const items = val?.length || []
        for (let index = 0; index < items.length; index++) {
          const item = items[index]
          this.$set(this.quantities, item.code, 1)
        }
      }
    },
    codes: {
      deep: true,
      handler (val) {
        const items = val?.length ? val : []
        const internalValue = []
        for (let index = 0; index < items.length; index++) {
          const item = items[index]
          internalValue.push({ code: item, quantity: this.quantities[item] })
        }
        this.internalValue = internalValue
      }
    },
    quantities: {
      deep: true,
      handler (val) {
        for (const [key, value] of Object.entries(val)) {
          const i = this.internalValue.findIndex(({ code }) => code === key)
          if (i > -1) this.internalValue[i].quantity = value
        }
      }
    }
    // lazyValue: {
    //   handler (val) {
    //     console.log('lazyValue', val)
    //     if (!val) return
    //     this.$emit('input', val)
    //   },
    //   deep: true
    // }
  },
  methods: {
    setValue (field, value) {
      console.log(field, value)
      this.lazyValue[field] = value
      this.$emit('input', this.lazyValue)
    },
    getMaterialCost (code, currency, pl = 'general') {
      const product = this.products[code]
      if (!product) console.log(code, { ...this.products })
      let value = 0
      const price = product.prices?.length
        ? (product.prices.find(({ priceList }) => priceList === pl) || product.prices[0])
        : null
      const projectedCostCurrency = product.projectedCostCurrency || 'CRC'
      const exchangeRate = projectedCostCurrency === currency ? 1
        : projectedCostCurrency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
      console.log(code, projectedCostCurrency, currency, exchangeRate)
      if (product?.projectedCost) return Number(product.projectedCost * exchangeRate)
      const steps = product?.steps || []
      steps.forEach(step => {
        value += (step.drm?.reduce((acc, { material, quantity }) => {
          const materialCost = this.getMaterialCost(material, currency)
          acc += (materialCost * quantity)
          return acc
        }, 0) || 0)
      })
      if (product?.isMaterial && price && !value) {
        const exchangeRate = price.currency === currency ? 1
          : price.currency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
        return Number(price.price * exchangeRate)
      }
      return value
    },
    getPrice ({ value, code, type }) {
      if (type === 3) return 0
      if (type === 1) return value
      const price = this.products[code]?.prices[0]
      const margin = price?.margin
      const amount = Number(price?.price || 0)
      const unitCost = this.getMaterialCost(code, this.currency, this.priceList)
      const unitPrice = margin ? (Number(unitCost) * (1 + amount)) : amount
      return price?.round ? Math.ceil(unitPrice) : Number(unitPrice.toFixed(2))
    }
  },
  beforeCreate () {
    // Acciones antes de crear el componente
  },
  created () {
    const items = this.fields?.length ? this.fields : []
    console.log('fields', items)
    for (let index = 0; index < items.length; index++) {
      const item = items[index]
      console.log('field', index, item.code)
      this.$set(this.quantities, item.code, 1)
    }
    // Acciones al crear el componente
  },
  beforeMount () {
    // Acciones antes de montar el componente
  },
  mounted () {
  },
  beforeUpdate () {
    // Acciones antes de actualizar el componente
  },
  updated () {
    // Acciones al actualizar el componente
  },
  beforeDestroy () {
  },
  destroyed () {
    // Acciones al destruir el componente
  }
}
</script>
<style scoped>
.datos-del-cliente {
    position: relative;
    line-height: 24px;
    font-weight: 500;
}
.titulo-seccion {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 0px;
    font-size: 24px;
    color: #480ca8;
    font-family: Rubik;
}
.vector-icon {
    width: 16.1px;
    position: relative;
    height: 16.1px;
}
.magebar-code-scan {
    width: 20.9px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 2.1px;
    box-sizing: border-box;
}
.input-texto-quantity {
    width: 260.19px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px; /* Ajusta el tamaño de fuente si es necesario */
}
.input-number {
    width: 260.19px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: none;
    outline: none;
    background: transparent;
    text-align: right;
    font-size: 14px; /* Ajusta el tamaño de fuente si es necesario */
}
.input-texto {
    width: 214px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: none;
    outline: none;
    background: transparent;
    text-align: center;
    font-size: 14px; /* Ajusta el tamaño de fuente si es necesario */
}
.caja-de-texto {
    width: 230px;
    border-radius: 16px;
    border: 1px solid #4361ee;
    box-sizing: border-box;
    height: 21px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
}
.group-icon {
    width: 18.8px;
    position: relative;
    height: 18.8px;
}
.magebar-code-scan-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    text-align: center;
}
.desplegable {
    width: 62.3px;
    position: relative;
    display: flex;
    align-items: center;
    flex-shrink: 0;
}
.icon-chevron {
    width: 10px;
    position: relative;
    height: 10px;
    overflow: hidden;
    flex-shrink: 0;
    object-fit: contain;
}
.desplegables {
    border-radius: 16px;
    border: 1px solid #4361ee;
    box-sizing: border-box;
    height: 21px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    gap: 6px;
}
.cantidad {
    position: relative;
    font-weight: 500;
}
.div {
    position: relative;
}
.wrapper {
    border-radius: 8px;
    border: 1px solid #4361ee;
    box-sizing: border-box;
    height: 22.7px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 4px 8px;
    font-size: 11px;
    color: #979797;
}
.cantidad-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    font-size: 12px;
    color: #535763;
}
.frame-parent {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 20px;
    font-size: 11px;
    color: #979797;
}
.container {
    border-bottom: 1px solid #4361ee;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 2px 8px;
    font-size: 11px;
    color: #979797;
}
.ancho-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
}
.frame-group {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 8px 20px;
    gap: 17px;
    font-size: 12px;
}
.productos-child {
    align-self: stretch;
    position: relative;
    max-width: 100%;
    overflow: hidden;
    max-height: 100%;
}
.crea-tu-formulario {
    align-self: stretch;
    position: relative;
    font-size: 20px;
    letter-spacing: 0.16px;
    line-height: 25.11px;
    font-weight: 500;
    font-family: Rubik;
}
.pregunta-de-seleccin-selecci {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
}
.pregunta-de-seleccin-selecci-wrapper {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}
.frame-div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}
.frame-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}
.custom-checkbox {
    width: 18.9px;
    height: 18.9px;
    position: relative;
    border-radius: 50%;
    border: 2.1px solid #4361ee;
    box-sizing: border-box;
    appearance: none; /* Oculta el estilo predeterminado del checkbox */
    cursor: pointer;
}
.custom-checkbox:checked {
    background-color: #4361ee; /* Color de fondo cuando está seleccionado */
}
.custom-radio {
    width: 18.9px;
    height: 18.9px;
    position: relative;
    display: inline-block;
    border-radius: 50%;
    border: 2.1px solid #4361ee;
    box-sizing: border-box;
    cursor: pointer;
}

/* Ocultar el input radio original */
.custom-radio input[type="radio"] {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}

/* Estilo para cuando el radio button está seleccionado */
.custom-radio input[type="radio"]:checked + .custom-radio {
    background-color: #4361ee;
}
.frame-child {
    width: 18.9px;
    height: 18.9px;
    position: relative;
    border-radius: 50%;
    border: 2.1px solid #4361ee;
    box-sizing: border-box;
    appearance: none; /* Oculta el radio button original */
    cursor: pointer;
}

.frame-child:checked {
    background-color: #4361ee; /* Color de fondo cuando está seleccionado */
}

.opcin-1-wrapper {
    width: calc(100% - 36px);
    border-radius: 8.37px;
    background-color: #ebf1ff;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 6.3px 16.7px;
    box-sizing: border-box;
}
.ellipse-parent {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    margin: 4px;
}
.frame-parent1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 6.3px;
    font-size: 11px;
    color: #000;
}
.frame-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 16.7px;
}
.rectangle-div {
    width: 18.8px;
    height: 18.8px;
    position: relative;
    border: 2.1px solid #4361ee;
    box-sizing: border-box;
    appearance: none; /* Remueve el estilo por defecto del checkbox */
    -webkit-appearance: none; /* Para compatibilidad con navegadores basados en WebKit */
    background-color: #fff; /* Fondo blanco para que parezca el div original */
    cursor: pointer; /* Añade un cursor de mano para simular el checkbox */
}

.rectangle-div:checked {
    background-color: #4361ee; /* Color de fondo al estar seleccionado */
}
.aadir-opcin {
    flex: 1;
    position: relative;
}
.detalles-aparecen-en-factura-wrapper {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}
.agregue-los-detalles {
    margin: 0;
}
.agregue-los-detalles-correspon-wrapper {
      align-self: stretch;
      border-radius: 8px;
      border: 1px solid #4361ee;
      padding: 6px 8px;
      display: block;
      resize: none; /* Evita que el usuario cambie el tamaño */
      font-family: inherit; /* Mantener la misma fuente */
      font-size: inherit; /* Mantener el tamaño de fuente */
}
.frame-wrapper3 {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 12px;
    color: #000;
}
.frame-parent4 {
    align-self: stretch;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 6px;
}
.div3 {
    width: 76.2px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: none;
    background-color: transparent;
    text-align: center;
    appearance: none; /* Elimina estilos por defecto de input */
    -moz-appearance: textfield; /* Elimina flechas en Firefox */
}

.div3::-webkit-inner-spin-button,
.div3::-webkit-outer-spin-button {
    -webkit-appearance: none; /* Elimina flechas en WebKit */
    margin: 0;
}
.wrapper1 {
    border-bottom: 1.5px solid #4361ee;
    box-sizing: border-box;
    height: 22.7px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    text-align: center;
}
.frame-parent6 {
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
}
.wrapper2 {
    width: 43px;
    border-bottom: 1.5px solid #4361ee;
    box-sizing: border-box;
    height: 22px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    text-align: center;
}
.frame-parent5 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;
    font-size: 12px;
    color: #535763;
}
.group-icon1 {
    width: 12.6px;
    position: relative;
    height: 12.6px;
}
.btn-text {
    position: relative;
    letter-spacing: 0.2px;
    line-height: 12.66px;
    font-weight: 500;
}
.boton-prinicipal {
    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.25), 0px 4px 16px rgba(114, 9, 183, 0.1) inset;
    border-radius: 21.29px;
    background-color: #b5179e;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    gap: 6px;
    text-align: center;
    font-size: 11px;
    color: #fff;
    font-family: Rubik;
    cursor: pointer;
}
.btn-text1 {
    position: relative;
    letter-spacing: 0.12px;
    line-height: 13.24px;
    font-weight: 500;
}
.buttonbtnprimary-colorbtn-r {
    border-radius: 22.27px;
    background-color: #f72585;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8.4px 14.6px;
}
.buttonbtnprimary-colorbtn-r-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: center;
    font-size: 12.55px;
    color: #fff;
}
.productos {
    width: 100%;
    position: relative;
    border-radius: 20.92px;
    background-color: #fff;
    border: 1.5px solid #4361ee;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 25.1px 24px;
    gap: 25.1px;
    text-align: left;
    font-size: 16px;
    color: #3f37c9;
    font-family: Roboto;
}
.productos-otro {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 25.1px;
    text-align: left;
    font-size: 16px;
    font-family: Roboto;
}
</style>
